/**
 * @file utils/office-preview.ts
 * @description 判斷已上傳檔案是否屬於「可轉 PDF 預覽」的 Office 文件類型。
 *
 * 瀏覽器無法原生渲染 Word/Excel/PowerPoint，這類副檔名改走後端
 * `GET /api/files/:id/preview.pdf`（LibreOffice headless 轉檔後回傳 PDF），
 * 而非直接開預簽名 URL。前端（決定是否呼叫轉檔端點）與後端（校驗副檔名、
 * 拒絕非 Office 檔案進 LibreOffice 轉檔）共用同一份白名單，避免兩邊各自維護漂移。
 */
/** 支援轉 PDF 預覽的副檔名（含新舊格式：OOXML + 舊版二進位格式）。 */
export const OFFICE_PREVIEW_EXTENSIONS = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
const OFFICE_PREVIEW_EXTENSION_SET = new Set(OFFICE_PREVIEW_EXTENSIONS);
/**
 * 取出檔名副檔名並判斷是否屬於可轉 PDF 預覽的 Office 類型；不屬於則回傳 null。
 *
 * @param filename 原始檔名（含副檔名）
 */
export function getOfficePreviewExtension(filename) {
    if (!filename)
        return null;
    const ext = filename.split('.').pop()?.toLowerCase();
    if (ext && OFFICE_PREVIEW_EXTENSION_SET.has(ext))
        return ext;
    return null;
}
